import React from 'react';
import { Link } from 'react-router-dom'

import { Row, Col, Layout} from 'antd'

import Footer from '../../components/Footer/Footer'
import classes from './PatientInformationSheet.css'


const { Content } = Layout;


export default class Home extends React.Component {

    render() {
        return (
            <div style={{ backgroundColor: '#FAFAFA' }}>
                <Layout className={classes.parentContainer}>
                    <Content className={classes.content}>
                        <Row>
                            <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                                <h1 ><span style={{ color: '#286DA8' }}>AcT</span></h1>

                                <Row type='flex' justify='center'>
                                    <Col xs={24} sm={18} md={18} lg={20} xl={22} className='frosted-card'>
                                      <h2>AcT - Patient Information Sheet</h2>
                                      <h3>Please select whether you would like to view the Text-only or Visual Patient Information Sheet</h3>
                                      <ul>
                                        <li><Link to='/patient-information-sheet-visual' style={{ color: '#FAFAFA' }} className='menu-item'> Visual Patient Information Sheet </Link></li>
                                        <li><Link to='/patient-information-sheet-text' style={{ color: '#FAFAFA' }} className='menu-item'> Text Only Patient Information Sheet </Link></li>
                                      </ul>
                                      <ul>
                                        <li><Link to='/' style={{ color: '#FAFAFA' }} className='menu-item'> Home </Link></li>
                                        <li><Link to='/randomize' style={{ color: '#FAFAFA' }} className='menu-item'> Randomize </Link></li>
                                      </ul>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Content>
                    <Footer />
                </Layout>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/PatientInformationSheet/PatientInformationSheet.js